import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import( '../views/home.vue'),
    redirect:"/index",
    children:[
      {
        path: '/index',
        component: () => import('@/views/VerticalFullscreenSwiper.vue'),
        meta: {
          title: '首页',
          keepAlive: true
        },
      },
      {
        path: '/service',
        component: () => import('@/views/service.vue'),
        meta: {
          title: '服务介绍',
          keepAlive: true
        },
      },
      {
        path: '/about',
        component: () => import('@/views/about.vue'),
        meta: {
          title: '企业介绍',
          keepAlive: true
        },
      },
      {
        path: '/information',
        component: () => import('@/views/information.vue'),
        meta: {
          title: '最新资讯',
        },
      },
      {
        path: '/informationDetail',
        component: () => import('@/views/informationDetail.vue'),
        meta: {
          title: '资讯详情'
        },
      },
      {
        path: '/shipDetail',
        component: () => import('@/views/shipDetail.vue'),
        meta: {
          title: '头部船东',
          keepAlive: true
        },
      }
    ]
  },
  {
    path: '/registerSet',
    component: () => import('@/views/registerSet.vue'),
    meta: {
      title: '企业注册管理'
    },
  },
  {
    path: '/login',
    component: () => import('@/views/login.vue'),
    meta: {
      title: '登录'
    },
  }
]

const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next)=>{
  document.title = to.meta.title
  window.scrollTo(0,0)
  next()
})
export default router
